import { OAuthExternalCallbackPage } from "src/features/integrations/sources/oauth/OAuthExternalCallbackPage.js";

// The login only stores a credential; organizations are picked in the portal afterwards.
export const VismaDineroExternalCallbackPage = () => {
	return <OAuthExternalCallbackPage successParam="credentialId" />;
};
